import { Link } from 'react-router-dom';
import { Clock, Heart, Shield, Ship, Sparkles, TrendingDown, Zap } from 'lucide-react';
import SectionHeader from './SectionHeader';
import PhoneCta from './PhoneCta';
import { HOOKS, HOOKS_SECTION } from '../data/hooksData';
import { PHONE_RAW } from '../constants/site';
import './CatchyHooksSection.css';

const ICONS = {
  trending: TrendingDown,
  zap: Zap,
  clock: Clock,
  shield: Shield,
  ship: Ship,
  sparkles: Sparkles,
  heart: Heart,
};

const tel = PHONE_RAW.replace(/[^\d+]/g, '');

export default function CatchyHooksSection() {
  return (
    <section className="section section--hooks" aria-label="Why book with us">
      <div className="container">
        <div className="hooks-ticker-wrap" aria-hidden>
          <div className="hooks-ticker">
            {[...HOOKS, ...HOOKS].map((item, i) => (
              <span key={`${item.id}-t${i}`}>{item.hook}</span>
            ))}
          </div>
        </div>
        <SectionHeader
          eyebrow={HOOKS_SECTION.eyebrow}
          title={HOOKS_SECTION.title}
          subtitle={HOOKS_SECTION.subtitle}
        />
        <div className="hooks-grid">
          {HOOKS.map((item, index) => {
            const Icon = ICONS[item.icon] || Zap;
            return (
              <article key={item.id} className="hooks-card" style={{ '--hooks-i': index }}>
                <div className="hooks-card__icon" aria-hidden>
                  <Icon size={24} strokeWidth={2} />
                </div>
                <h3 className="hooks-card__hook">{item.hook}</h3>
                <p className="hooks-card__tagline">{item.tagline}</p>
                <a href={`tel:${tel}`} className="hooks-card__link">
                  Call now <span aria-hidden>→</span>
                </a>
              </article>
            );
          })}
        </div>
        <div className="hooks-footer">
          <p className="hooks-footer__pitch">
            <strong>Ready when you are.</strong> Search online or talk to an agent — same great
            support either way.
          </p>
          <Link to="/flight/support" className="hooks-footer__text-link">
            Message us instead
          </Link>
        </div>
        <PhoneCta
          variant="compact"
          badge="Talk to a travel pro"
          title="Get a custom quote in minutes"
          subtitle="Flights, hotels, packages & more — one call does it all."
          className="hooks-phone-cta"
        />
      </div>
    </section>
  );
}
